import debugLib from "debug";

const main = debugLib("main");
const socket = debugLib("socket");
const sessionSocket = debugLib("sessionSocket");
const game = debugLib("game");
const error = debugLib("error");
const debug = debugLib("debug");
const session = debugLib("session");
const fx = debugLib("fx");
const sessionFx = debugLib("sessionFx");
const event = debugLib("event");
const sessionEvent = debugLib("sessionEvent");

export const ALL_NAMESPACES = "main,session,game,error,debug,socket,sessionSocket,fx,sessionFx,event,sessionEvent";

export { main, socket, game, error, debug, fx, sessionFx, session, sessionSocket, event, sessionEvent };
export default { main, socket, game, error, debug, fx, sessionFx, session, sessionSocket, event, sessionEvent };
